import AppLoader from '@/components/AppLoader';
import { ICalendar } from '@/types/ICalendar';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { Drawer, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay } from '@chakra-ui/react';
import { t } from 'i18next';
import EventDetailsBody from './components/event-details-form/event-details-form.view';
import { useEventDetailsController } from './event-details.controller';

interface IProps {
	/**
	 * If an event is passed the modal wont try to fetch from the server.
	 */
	event: ICalendarEvent | null;
	isOpen: boolean;
	calendar: ICalendar;
	onClose: () => void;
	onDelete: (event: ICalendarEvent) => void;
	onSave: (event: ICalendarEvent) => void;
}

export default function EventDetailsModal(props: IProps) {
	const { event } = useEventDetailsController(props);

	return (
		<Drawer isOpen={props.isOpen} onClose={props.onClose} size="xl">
			<DrawerOverlay />
			<DrawerContent>
				<DrawerHeader>{t('Edit event')}</DrawerHeader>
				<DrawerCloseButton />
				{event ? (
					<EventDetailsBody
						onSave={props.onSave}
						onDelete={props.onDelete}
						onClose={props.onClose}
						calendar={props.calendar}
						event={event}
					/>
				) : (
					<AppLoader />
				)}
			</DrawerContent>
		</Drawer>
	);
}
